import React, { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getProfile } from '../../api/auth'
import { addInquiries } from '../../api/inquiries'
import { postPicture } from '../../api/orderHistory'
import { getMall } from '../../api/product'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

type ImageFileType = {
  id: string
  imgUrl: string | null
}

// 이미지 경로
const imgURL = '/images'

export default function InquiryWrite() {
  const [inquiriesType, setInquiriesType] = useState<any>(null)
  const [selectedType, setSelectedType] = useState<string>('')
  const [title, setTitle] = useState<string>('')
  const [content, setContent] = useState<string>('')
  const [imageFile, setImageFile] = useState<ImageFileType[]>([
    { id: 'img_file0', imgUrl: null },
    { id: 'img_file1', imgUrl: null },
    { id: 'img_file2', imgUrl: null },
  ])
  const [directMail, setDirectMail] = useState<boolean>(false)
  const [smsAgree, setSmsAgree] = useState<boolean>(false)
  const { isAppView } = useAppContext()
  const { setIsLottie } = useCommonContext()
  const location = useLocation()
  const navigate = useNavigate()
  const titleRef = useRef<HTMLInputElement>(null)
  const contentRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    getMall().then((res) => {
      setInquiriesType(res.data.inquiryType)
    })
  }, [])

  useEffect(() => {
    getProfile().then((res) => {
      setDirectMail(res.data.directMailAgreed)
      setSmsAgree(res.data.smsAgreed)
    })
  }, [location])

  function uploadFile(e: any, idx: number) {
    if (!e.target.files) {
      return
    }
    const pictureSize = e.target.files[0].size
    const maxSize = 5 * 1024 * 1024
    if (pictureSize > maxSize) {
      alert('첨부할 수 있는 이미지 파일은 5MB이하입니다.')
      setIsLottie(false)
      return
    }
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    const copy = [...imageFile]
    postPicture(formData)
      .then((res) => {
        copy[idx].imgUrl = res.data.imageUrl
        setImageFile(copy)
        setTimeout(() => {
          setIsLottie(false)
        }, 1000)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleSelectChange = (e: any) => {
    if (titleRef) {
      titleRef.current?.focus()
    }
  }

  function deletePicture(idx: number) {
    const copy = [...imageFile]
    copy[idx].imgUrl = null
    setImageFile(copy)
  }

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>1:1 문의 작성</PageTitle>
            <div className='inquiry_write'>
              <div className='inquiry_write_box'>
                <div className='inquiry_type'>
                  <p>문의 내용 유형</p>
                  <div>
                    <select
                      name='inquiry_type'
                      id='inquiry_type'
                      value={selectedType}
                      onChange={(e) => {
                        setSelectedType(e.target.value)
                        handleSelectChange(e)
                      }}
                    >
                      <option value=''>문의 내용 유형 선택</option>
                      {inquiriesType !== null &&
                        inquiriesType.map((type: any) => (
                          <option key={type.inquiryTypeNo} value={type.inquiryTypeNo}>
                            {type.inquiryTypeName}
                          </option>
                        ))}
                    </select>
                    <img src={`${imgURL}/icon_arrow_down.png`} alt='' />
                  </div>
                </div>
                <div className='inquiry_title'>
                  <p>제목</p>
                  <input
                    ref={titleRef}
                    type='text'
                    placeholder='제목을 입력해주세요.'
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
                <p>내용</p>
                <TextAreaWrap>
                  <textarea
                    ref={contentRef}
                    name=''
                    id=''
                    placeholder='내용을 입력해주세요.'
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                  <div className='filewrap'>
                    <ul>
                      {imageFile.map((el: any, idx: number) => {
                        return (
                          <li key={el.id}>
                            <input
                              type='file'
                              name='img_file1'
                              id={`img_file${idx}`}
                              accept='image/*'
                              onChange={(e) => {
                                setIsLottie(true)
                                uploadFile(e, idx)
                              }}
                            />
                            <label
                              htmlFor={`img_file${idx}`}
                              id={`label_file${idx}`}
                              style={{
                                border: el.imgUrl ? 'none' : '1px dashed var(--colGray4)',
                                backgroundImage: el.imgUrl ? `url(${el.imgUrl})` : 'none',
                                backgroundColor: el.imgUrl ? 'none' : 'var(--colGray1)',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                boxShadow: el.imgUrl ? '0px 0px 0px 1px rgba(0, 0, 0, 0.05)' : 'none',
                              }}
                            >
                              {/* <img
                              src={el.imgUrl}
                              style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '8px',
                                display: el.imgUrl ? 'block' : 'none',
                              }}
                            ></img> */}
                              <span
                                style={{
                                  display: el.imgUrl ? 'none' : 'block',
                                }}
                              ></span>
                            </label>
                            {el.imgUrl ? (
                              <button
                                type='button'
                                id='button-delete-1'
                                onClick={() => {
                                  deletePicture(idx)
                                }}
                              ></button>
                            ) : null}
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                  <p>사진은 5MB 이내, 3개까지 첨부 가능합니다.</p>
                  <div className='button_wrap'>
                    <button
                      className='cancel_btn'
                      onClick={() => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.goBack)
                        } else {
                          navigate(-1)
                        }
                      }}
                    >
                      취소
                    </button>
                    <button
                      onClick={() => {
                        if (selectedType === '') {
                          alert('문의 유형을 선택해주세요.')
                          return
                        }
                        if (title === '') {
                          alert('제목을 입력해 주세요.')
                          titleRef.current?.focus()
                          return
                        }
                        if (content === '') {
                          alert('내용을 입력해 주세요.')
                          contentRef.current?.focus()
                          return
                        }

                        const array: any = []
                        imageFile.map((el: any) => {
                          if (el.imgUrl !== null) {
                            array.push(el.imgUrl)
                          }
                        })

                        addInquiries(selectedType, title, content, directMail, smsAgree, array).then((res) => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.goBack)
                          } else {
                            navigate(-1)
                          }
                        })
                      }}
                      type='button'
                      className='submit_btn'
                    >
                      확인
                    </button>
                  </div>
                </TextAreaWrap>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const TextAreaWrap = styled.div`
  margin-top: 8px;
  & textarea {
    width: 100%;
    height: 208px;
    padding: 8px 16px;
    border: 1px solid var(--colGray3);
    border-radius: 5px;
    color: var(--colBlack);
    font-size: 14px;
    line-height: 24px;
    font-family: 'Pretendard', sans-serif;
    &:focus {
      border: 1px var(--colBlack) solid;
    }
  }
  & .filewrap {
    margin: 16px 0 8px 0;
    & ul {
      display: flex;
      gap: 10px;
      & li {
        position: relative;
        & input {
          padding: 0;
          font-size: 0;
          line-height: inherit;
          color: transparent;
          letter-spacing: 0;
          width: 0 !important;
          display: none;
        }
        & label {
          position: relative;
          display: block;
          width: 80px;
          height: 80px;
          border: 1px dashed var(--colGray4);
          background: var(--colGray1);
          border-radius: 8px;
          cursor: pointer;
          & div {
          }
          & span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 12px;
            height: 12px;
            background: url('../images/icon_plus2.svg') no-repeat;
            background-size: contain;
          }
        }
        & button {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0;
          border: 0;
          width: 32px;
          height: 32px;
          background: url('../images/icon_clear_button.png') no-repeat;
          background-size: contain;
        }
      }
    }
  }
  & .button_wrap {
    margin-top: 24px;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    text-align: center;
    & .cancel_btn {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      color: var(--colBlack);
      background: var(--colWhite);
      border: 1px solid var(--colGray3);
      border-radius: 5px;
      padding: 11px;
    }
    & .submit_btn {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      color: var(--colWhite);
      background: var(--colBlack);
      border: 0;
      border-radius: 5px;
      padding: 11px;
    }
  }
`
